import type { Locality } from "@ebay/locale-ebay";
import { calculateGoogleMapsZoomLevel } from "./helpers";
import { BERLIN_CENTER, DEFAULT_MARKETPLACE_CENTER, DEFAULT_RADIUS_M, DEFAULT_ZOOM_LEVEL, DE_MARKETPLACE_ID, MAX_ZOOM_LEVEL } from "./const";

export type CreateMapOptions = {
  mapsLibrary: google.maps.MapsLibrary;
  mapId: string;
  mapEl?: HTMLElement;
  isMobile?: boolean;
  marketplaceId?: string;
  locality?: Locality;
};

export function createMap(options: CreateMapOptions): google.maps.Map {
  const { mapsLibrary, mapEl, mapId, isMobile, marketplaceId = DE_MARKETPLACE_ID } = options;

  if (!mapEl) throw Error("Map element not found");

  const center = DEFAULT_MARKETPLACE_CENTER[marketplaceId] || BERLIN_CENTER;
  const radiusInMeters = DEFAULT_RADIUS_M;

  return new mapsLibrary.Map(mapEl, {
    center,
    zoom: calculateGoogleMapsZoomLevel(mapEl, center, radiusInMeters) || DEFAULT_ZOOM_LEVEL,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    zoomControl: false,
    disableDefaultUI: !isMobile,
    maxZoom: MAX_ZOOM_LEVEL,
    mapId,
    gestureHandling: "greedy",
    isFractionalZoomEnabled: true,
    clickableIcons: false,
  });
}
